import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   DeleteRolevalues
export const DeleteRolevalues = createSlice({
  name: "DeleteRolevalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    DeleteRolevalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_DeleteRolevalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_DeleteRolevalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    DeleteRolevalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_DeleteRolevalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchDeleteRolevalues:(state)=>{
        state.switch = false
    }
  },
});
export default DeleteRolevalues.reducer;
export const {
  DeleteRolevalues_datagrid,
  success_api_call_DeleteRolevalues_datagrid,
  failure_api_call_DeleteRolevalues_datagrid,
  create_DeleteRolevalues_datagrid_complete_api,
  DeleteRolevalues_datagrid_is_success,false_switchDeleteRolevalues
} = DeleteRolevalues.actions;
